const MAX_LENGTH = 4

export const shortenTokenSymbol = (symbol: string, length = MAX_LENGTH) => {
  if (symbol.length > length) {
    return `${symbol.slice(0, length)}...`
  }

  return symbol
}
